/**
 * Helpers for Firebase RTDB live pick counts (game page).
 * Room id scopes stats per org + session + theme instance.
 */

export function makePickRoomId(sessionId, organizationId, themename) {
  const raw = `${organizationId || ''}_${sessionId || ''}_${themename || ''}`;
  return raw.replace(/[^a-zA-Z0-9_-]/g, '_');
}

/** RTDB path segments should avoid . # $ [ ] / — encode item display names */
export function encodePickItemKey(name) {
  const s = String(name);
  try {
    const base64 = btoa(unescape(encodeURIComponent(s)));
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/u, '');
  } catch {
    return encodeURIComponent(s).replace(/[^a-zA-Z0-9_.~-]/g, '_');
  }
}

export function decodePickItemKey(key) {
  try {
    let base64 = key.replace(/-/g, '+').replace(/_/g, '/');
    const pad = base64.length % 4;
    if (pad) base64 += '='.repeat(4 - pad);
    return decodeURIComponent(escape(atob(base64)));
  } catch {
    return key;
  }
}

/**
 * Maps RTDB value at pickRooms/.../slides to positionStats shape:
 * { "0": { "ItemName": count }, ... }
 */
export function slidesSnapshotToPositionStats(val) {
  if (!val || typeof val !== 'object') return {};
  const out = {};
  Object.entries(val).forEach(([slideIdx, slideNode]) => {
    if (!slideNode || typeof slideNode !== 'object') return;
    const items = slideNode.items;
    if (!items || typeof items !== 'object') return;
    out[String(slideIdx)] = {};
    Object.entries(items).forEach(([enc, n]) => {
      const count = Number(n);
      if (Number.isNaN(count)) return;
      out[String(slideIdx)][decodePickItemKey(enc)] = count;
    });
  });
  return out;
}
